import React, { ReactElement, useState } from "react";
import { TextArea } from "../../../../shared/forms";
import { CopilotActionSteps } from "../copilot-actions";
import { toLiteral } from "../../../../../helper/locale-utils";

/**
 * Component that renders the text input answer type
 */
const TextAreaAnswer: React.FC<any> = (props: any): ReactElement => {
  const { dialogStep, triggerAction } = props;

  const [inputValue, setInputValue] = useState();

  function handleSubmit(nextStepId?: string) {
    triggerAction(inputValue, nextStepId);
  }

  const renderAnswerContainer = (_dialogStep: CopilotActionSteps) => {
    if (Array.isArray(_dialogStep?.answers)) {
      const answerConfig = _dialogStep?.answers?.[0];
      return (
        <React.Fragment>
          <TextArea name={_dialogStep?.id} placeholder={answerConfig?.label} type="text" onChange={(e: any) => setInputValue(e?.target?.value)} />
          <div className="flex">
            <button className="button-icon mla" onClick={() => handleSubmit(answerConfig?.nextStep)}>
              <span className="material-icons">send</span>
            </button>
          </div>
        </React.Fragment>
      );
    } else {
      return toLiteral({ id: "Sorry, something went wrong when loading the answer selector" });
    }
  };

  return <React.Fragment>{renderAnswerContainer(dialogStep)}</React.Fragment>;
};

export default TextAreaAnswer;
